import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()({
  overspendCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  
  legendContainer: {
    marginLeft: '2rem',
  },
});
